export const checkRequire = (value: string | number | Array<string>): string => {
  if (value === '' || isEmptyArray(value) || value === undefined) return '必須項目です'

  return ''
}

const isEmptyArray = (value: string | number | Array<string>): boolean => {
  return Array.isArray(value) && value.length === 0
}
